
import ProfitRecyclage from "@/pages/sites/ProfitRecyclage";
import BelleRecyclage from "@/pages/sites/BelleRecyclage";
import BrianeJeanRecuperation from "@/pages/sites/BrianeJeanRecuperation";
import LescoutRecyclage from "@/pages/sites/LescoutRecyclage";
import FabrudeRecyclage from "@/pages/sites/FabrudeRecyclage";
import CasseAutoBassin from "@/pages/sites/CasseAutoBassin";
import RMRecyclage from "@/pages/sites/RMRecyclage";
import BennesProfit from "@/pages/sites/BennesProfit";
import CarmausineRecuperation from "@/pages/sites/CarmausineRecuperation";
import DynamicSitePage from "@/pages/sites/DynamicSitePage";

// Routes pour les sites avec données réelles de Supabase
export const individualSiteRoutes = [
  // Route dynamique principale basée sur les vraies données Supabase
  { path: "/site/:siteName/:city", element: DynamicSitePage },
  
  // Routes spécifiques basées sur les vraies données de Supabase
  // Bellé recyclage - Sainte-Radegonde (12850)
  { path: "/site/belle-recyclage/sainte-radegonde", element: BelleRecyclage },
  { path: "/sites/belle-recyclage", element: BelleRecyclage }, // Backwards compatibility
  
  // Briane Jean Récupération - Lédergues (12170)  
  { path: "/site/briane-jean-recuperation/ledergues", element: BrianeJeanRecuperation },
  { path: "/sites/briane-jean-recuperation", element: BrianeJeanRecuperation }, // Backwards compatibility
  
  // Carmausine de récupération - Carmaux (81400)
  { path: "/site/carmausine-de-recuperation/carmaux", element: CarmausineRecuperation },
  { path: "/sites/carmausine-recuperation", element: CarmausineRecuperation }, // Backwards compatibility
  
  // Casse Auto du Bassin - Viviez (12110)
  { path: "/site/casse-auto-du-bassin/viviez", element: CasseAutoBassin },
  { path: "/sites/casse-auto-bassin", element: CasseAutoBassin }, // Backwards compatibility
  
  // Fabrude Recyclage - Saint-Paul-des-Landes (15250)
  { path: "/site/fabrude-recyclage/saint-paul-des-landes", element: FabrudeRecyclage },
  { path: "/sites/fabrude-recyclage", element: FabrudeRecyclage }, // Backwards compatibility
  
  // Lescout Recyclage - Lescout (81110)
  { path: "/site/lescout-recyclage/lescout", element: LescoutRecyclage },
  { path: "/sites/lescout-recyclage", element: LescoutRecyclage }, // Backwards compatibility
  
  // Profit recyclage - Beauchamp (95250) région parisienne
  { path: "/site/profit-recyclage/beauchamp", element: ProfitRecyclage },
  { path: "/sites/profit-recyclage", element: ProfitRecyclage }, // Backwards compatibility
  
  // RM Recyclage - Coren (15100) Cantal
  { path: "/site/rm-recyclage/coren", element: RMRecyclage },
  { path: "/sites/rm-recyclage", element: RMRecyclage }, // Backwards compatibility
];
